import SwipeUpModal from 'components/SwipeUpModal';
import { actionSetWorkOrderOpActionLoading } from 'lib/actions';
import useSelectActivity from 'lib/hooks/useSelectActivity';
import { getHasOpenActivitySet } from 'lib/selectors/getHasOpenActivitySet';
import useCreateActivitySetWithWorkOrder from 'pages/SelectJob/useCreateActivitySetWithWorkOrder';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMachine } from 'lib/selectors/getMachine';
import { getCurrentWorkOrderOp } from 'lib/selectors/getCurrentWorkOrderOp';
import { useTranslation } from 'react-i18next';

import useChangeActivities from 'components/LaborTicket/hooks/useChangeActivities';
import { throwSuccessToast } from 'lib/utils/toast';
import useLookupActivityTypeName from 'lib/hooks/useLookupActivityTypeName';
import useRequestJobStartAt from 'lib/hooks/useRequestJobStartAt';
import { Table } from './Table';

const SelectActivity = () => {
  const { t } = useTranslation();
  const {
    selectActivityOpen,
    selectActivityOptions,
    closeSelectActivity,
  } = useSelectActivity();

  const dispatch = useDispatch();
  const hasOpenActivitySet = useSelector(getHasOpenActivitySet);
  const machine = useSelector(getMachine);

  const currentWorkOrderOp = useSelector(getCurrentWorkOrderOp);

  const { workOrderOp, partOperation } = selectActivityOptions || {};

  const selectedWorkOrderOp = workOrderOp || currentWorkOrderOp;

  const requestJobStartAt = useRequestJobStartAt();
  const requestCreateActivitySetWithWorkOrder = useCreateActivitySetWithWorkOrder(
    {
      machine,
      workOrderOp: selectedWorkOrderOp,
    }
  );
  const requestChangeActivities = useChangeActivities();
  const lookupActivityTypeName = useLookupActivityTypeName();

  const handleActivityTypeSelected = async (activityTypeRef) => {
    if (hasOpenActivitySet && selectedWorkOrderOp) {
      dispatch(actionSetWorkOrderOpActionLoading(true));
      await requestChangeActivities({
        pendingActivityTypeRef: activityTypeRef,
      });

      const activityTypeName = lookupActivityTypeName(activityTypeRef);
      if (currentWorkOrderOp) {
        throwSuccessToast(t('Switched Activity:', { activityTypeName }));
      }
    } else {
      try {
        const startAt = await requestJobStartAt();
        dispatch(actionSetWorkOrderOpActionLoading(true));

        await requestCreateActivitySetWithWorkOrder({
          activityTypeRef,
          partOperation,
          startAt,
        });
      } catch (error) {
        return dispatch(actionSetWorkOrderOpActionLoading(false));
      }
    }

    dispatch(actionSetWorkOrderOpActionLoading(false));
    return closeSelectActivity();
  };

  const headerText =
    selectedWorkOrderOp && selectedWorkOrderOp?.workOrder
      ? `${selectedWorkOrderOp.workOrderId} | ${selectedWorkOrderOp.workOrder.partNumber} Op ${selectedWorkOrderOp.sequenceNumber}`
      : t('Select Activity');

  return (
    <SwipeUpModal
      isOpen={selectActivityOpen}
      header={headerText}
      onClose={() => {
        return closeSelectActivity();
      }}
      details={
        <Table
          workOrderOp={selectedWorkOrderOp}
          onActivityTypeSelect={handleActivityTypeSelected}
        />
      }
    />
  );
};

export { SelectActivity };
